import { useQueryClient } from '@tanstack/react-query';
import { useMutation } from 'query';
import { inviteProgram } from '../../services';
import { getProgramUsersInfiniteQueryKey } from '../keys';

type InviteProgramVariables = {
  communityIds: string[];
  organizationIds: string[];
  programId: string;
  userIds: string[];
};

export const useInviteProgramMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, InviteProgramVariables>({
    async mutationFn({ communityIds, organizationIds, programId, userIds }) {
      const { data } = await inviteProgram({
        body: {
          program: {
            /* eslint-disable @typescript-eslint/naming-convention -- Start: key is defined by Backend API endpoint */
            community_ids: communityIds,
            organization_ids: organizationIds,
            user_ids: userIds,
            /* eslint-enable @typescript-eslint/naming-convention -- End: key is defined by Backend API endpoint */
          },
        },
        routeParams: { programId },
      });

      return data;
    },
    async onSuccess(_, { programId }) {
      await queryClient.invalidateQueries({
        queryKey: getProgramUsersInfiniteQueryKey({ filter: { programId } }),
      });
    },
  });
};
